(() => {
  class ManualProductReviews {
    constructor(section) {
      this.section = section;
      this.viewport = section.querySelector('[data-reviews-viewport]');
      this.track = section.querySelector('[data-reviews-track]');
      this.slides = Array.from(
        section.querySelectorAll('[data-review-slide]')
      );

      this.previousButton = section.querySelector(
        '[data-reviews-previous]'
      );

      this.nextButton = section.querySelector(
        '[data-reviews-next]'
      );

      this.currentIndex = 0;
      this.resizeTimer = null;

      this.init();
    }

    init() {
      this.setupReadMore();
      this.setupCarousel();
      this.setupImageModal();
    }

    getSlidesPerView() {
      if (window.innerWidth <= 749) {
        return 1;
      }

      if (window.innerWidth <= 989) {
        return 2;
      }

      return 3;
    }

    getMaximumIndex() {
      return Math.max(
        0,
        this.slides.length - this.getSlidesPerView()
      );
    }

    setupCarousel() {
      if (!this.viewport || !this.track || !this.slides.length) {
        return;
      }

      if (this.previousButton) {
        this.previousButton.addEventListener('click', () => {
          this.goToSlide(this.currentIndex - 1);
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => {
          this.goToSlide(this.currentIndex + 1);
        });
      }

      window.addEventListener('resize', () => {
        window.clearTimeout(this.resizeTimer);

        this.resizeTimer = window.setTimeout(() => {
          const maximumIndex = this.getMaximumIndex();

          if (this.currentIndex > maximumIndex) {
            this.currentIndex = maximumIndex;
          }

          this.updateCarousel();
          this.setupReadMore();
        }, 150);
      });

      this.updateCarousel();
    }

    goToSlide(index) {
      const maximumIndex = this.getMaximumIndex();

      this.currentIndex = Math.min(
        Math.max(index, 0),
        maximumIndex
      );

      this.updateCarousel();
    }

    updateCarousel() {
      const targetSlide = this.slides[this.currentIndex];

      if (!targetSlide || !this.track) {
        return;
      }

      this.track.style.transform =
        `translate3d(-${targetSlide.offsetLeft}px, 0, 0)`;

      if (this.previousButton) {
        this.previousButton.disabled = this.currentIndex === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled =
          this.currentIndex >= this.getMaximumIndex();
      }
    }

    setupReadMore() {
      const toggles = this.section.querySelectorAll(
        '[data-review-toggle]'
      );

      toggles.forEach((toggle) => {
        if (toggle.dataset.initialized === 'true') {
          return;
        }

        toggle.dataset.initialized = 'true';

        toggle.addEventListener('click', () => {
          const content = toggle.closest(
            '.manual-reviews__content'
          );

          const card = toggle.closest(
            '.manual-reviews__card'
          );

          const shortText = content?.querySelector(
            '[data-review-short]'
          );

          const fullText = content?.querySelector(
            '[data-review-full]'
          );

          const isExpanded =
            toggle.getAttribute('aria-expanded') === 'true';

          const nextExpanded = !isExpanded;

          if (shortText && fullText) {
            if (nextExpanded) {
              shortText.hidden = true;
              fullText.hidden = false;
              fullText.insertAdjacentElement('afterend', toggle);
              toggle.classList.add('is-below');
            } else {
              fullText.hidden = true;
              shortText.hidden = false;
              shortText.insertAdjacentElement('afterend', toggle);
              toggle.classList.remove('is-below');
            }
          }

          card?.classList.toggle('is-expanded', nextExpanded);

          toggle.textContent = nextExpanded
            ? 'Read Less'
            : 'Read More';

          toggle.setAttribute(
            'aria-expanded',
            String(nextExpanded)
          );
        });
      });
    }

    setupImageModal() {
      const modal = this.section.querySelector(
        '[data-review-modal]'
      );

      const modalImage = this.section.querySelector(
        '[data-review-modal-image]'
      );

      const closeButton = this.section.querySelector(
        '[data-review-modal-close]'
      );

      const imageButtons = this.section.querySelectorAll(
        '[data-review-image-trigger]'
      );

      if (!modal || !modalImage || !imageButtons.length) {
        return;
      }

      const closeModal = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');

        modalImage.src = '';
        modalImage.alt = '';

        document.body.style.overflow = '';
      };

      imageButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const image = button.querySelector('img');

          if (!image) {
            return;
          }

          modalImage.src = image.currentSrc || image.src;
          modalImage.alt =
            image.alt || 'Customer review product image';

          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');

          document.body.style.overflow = 'hidden';

          closeButton?.focus();
        });
      });

      closeButton?.addEventListener('click', closeModal);

      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          closeModal();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (
          event.key === 'Escape' &&
          modal.classList.contains('is-open')
        ) {
          closeModal();
        }
      });
    }
  }

  function initializeManualReviews(root = document) {
    root
      .querySelectorAll('[data-manual-reviews]')
      .forEach((section) => {
        if (section.dataset.initialized === 'true') {
          return;
        }

        section.dataset.initialized = 'true';
        new ManualProductReviews(section);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeManualReviews();
    });
  } else {
    initializeManualReviews();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeManualReviews(event.target);
    }
  );
})();